import { FC } from "react";
import { Table, makeStyles, TableBody, Paper, TableCell, TableContainer, TableHead, TableRow } from "@material-ui/core";
import useTranslation from "next-translate/useTranslation";
import { TheCycleverseTheme } from "src/theme";

const useTableStyles = makeStyles((theme: TheCycleverseTheme) => ({
  container: {
    borderRadius: 0,
    width: "100%",
    margin: "auto",
    boxShadow: "none",
    fontSize: "16px",
    marginTop: "20px",
    "@media (max-width: 490px)": {
      width: "90vw",
    },
  },

  tableCell: (centered: any) => {
    return {
      border: "0.5px solid #CED4D9",
      fontSize: "16px",
      lineHeight: "23px",
      textAlign: centered ? "center" : "left",
    };
  },

  headerRow: {
    background: theme.highlightGradientBg,
    fontSize: 16,
  },
  headerCell: {
    fontWeight: 700,
    fontSize: "16px",
    color: "white",
    fontFamily: theme.typography.fontFamily,
    lineHeight: "23px",
  },
}));

const CalculatorTable: FC<{
  headers?: string[];
  centered?: boolean;
  rows?: { id: string; styles?: any; cells: string[] }[];
}> = ({ headers, rows, centered }) => {
  const { t } = useTranslation("lumenLuxRechner");
  const classes = useTableStyles(centered);
  return (
    <TableContainer component={Paper} className={classes.container}>
      <Table size="small" aria-label="customized table">
        {headers ? (
          <TableHead>
            <TableRow className={classes.headerRow}>
              {headers?.map((header) => (
                <TableCell key={header} className={`${classes.tableCell} ${classes.headerCell}`}>
                  {t(`${header}`)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {rows?.map((row) => (
            <TableRow key={row.id}>
              {row?.cells?.map((cell) => (
                <TableCell
                  style={{ width: row?.styles?.width }}
                  align={row?.styles?.textAlign}
                  key={cell}
                  className={`${classes.tableCell}`}
                >
                  {t(`${cell}`)}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CalculatorTable;
